import { render, staticRenderFns } from "./Image_v1.vue?vue&type=template&id=2b757076&scoped=true&lang=pug"
import script from "./Image_v1.vue?vue&type=script&lang=js"
export * from "./Image_v1.vue?vue&type=script&lang=js"
import style0 from "./Image_v1.vue?vue&type=style&index=0&id=2b757076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b757076",
  null
  
)

export default component.exports